export default __webpack_public_path__ + "static/media/overlay.2ebd2a9c.jpg";